import React from 'react'
import { connect } from 'react-redux'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextButton from 'components/Luxkit/Button/TextButton'
import { getSupportContact } from 'selectors/supportContactSelector'

interface Props {
  currentContact: App.GeoContacts;
}

function CruiseSupportButton({
  currentContact,
}: Props) {
  const contact = currentContact[currentContact.default]

  return <TextButton
    kind="secondary"
    fit="full-width"
    startIcon={<LinePhoneIcon />}
    href={`tel:${contact.number}`}
  >
    Call {contact.humanReadable}
  </TextButton>
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(CruiseSupportButton)
